import AContainer from '../library/ExtendedObjects/AContainer.js';
import gameData from '../gameData.js';
import Utils from '../library/Utils.js';
import ACanvas from '../library/ExtendedObjects/ACanvas.js';
import ABCyaLib from '@abcya/abcya_lib';
import { Audio } from '@abcya/abcya_phaser';

export default class Fuzzbug extends AContainer {
  constructor(scene, startX, startY, ind, anim) {
    super(scene);

    this.startX = startX;
    this.startY = startY;
    this.endX = startX;
    this.endY = startY;
    this.startAnim = anim;
    this.ind = ind;
    this.isStationary = false;
    this.dir = "idle";

    this.blendTime = 500;
    this.weightedWingAnims;

    this.textureKey = Utils.GetRandomString();
    this.scene.textures.addImage(this.textureKey, this.scene.textures.get("fuzzbug.png").getSourceImage());

    this.shadow = this.scene.addImage(0, 0, "shadow");

    this.character = this.scene.addSpine(0, 0, 'fuzzbug' + this.ind, this.startAnim, true, (obj) => { this.completeCheck(obj); });

    this.scene.add.existing(this);
    this.add(this.shadow);
    this.add(this.character.spine);

    this.setPosition(this.startX, this.startY);

    this.setInitParams();

    this.enterGame();
  }

  setInitParams() {
    this.character.setDefaultMix(this.blendTime / 1000);
    this.isBlending = false;

    this.bodyData = { x: 0, y: 387, texture: "Base" };
    this.atlasSize = { width: 512, height: 512 };

    this.masks = [];
    this.numPaints = 0;

    this.stencilData = {
      Stencil1: { x: -10, y: -435 },
      Stencil2: { x: -40, y: -435 },
      Stencil3: { x: -52, y: -435 },
      Stencil4: { x: -16, y: -435 },
      Stencil5: { x: -104, y: -483 }
    };

    for (let i = 0; i < 5; i++) {
      this.stencilData["Stencil" + (i + 1)].x += this.bodyData.x;
      this.stencilData["Stencil" + (i + 1)].y += this.bodyData.y;
    }

    this.color = "f2eddf";
    this.colorName = ""
    this.stencil = "";
    this.stencilColor = "";
    this.stencilName = "";

    if (gameData.currentScene === "Customize") {
      this.character.setAttachment("images/PatternsSign", null);
    }
    if (gameData.currentScene === "Intro") {
      this.character.spine.setScale(.65);

      if (this.ind === 1) this.character.setAttachment("images/PatternsSign", ABCyaLib.Environment.instance.locale === ABCyaLib.Environment.LOCALES.esUS ? "images/Logo_Counting_ES" : "images/PatternsSign");
      else if (this.ind === 2) this.character.setAttachment("images/PatternsSign", ABCyaLib.Environment.instance.locale === ABCyaLib.Environment.LOCALES.esUS ? "images/Logo_Sorting_ES" : "images/Logo_Sorting");
      else if (this.ind === 3) this.character.setAttachment("images/PatternsSign", ABCyaLib.Environment.instance.locale === ABCyaLib.Environment.LOCALES.esUS ? "images/Logo_And_Patterns_ES" : "images/Logo_And_Patterns");

      this.maxWidth = 200;
      this.maxHeight = 200;
      this.setSize(this.maxWidth, this.maxHeight);

      //must enable first to allow for hit area manipulation before turning off
      this.enabled();
      this.input.hitArea.centerX = 100;
      this.input.hitArea.centerY = -50;
      this.disabled();

      this.on('pointerup', () => {
        //console.log("giggling");
        this.scene.playSound("FB_giggle", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
        this.disabled();
        this.character.play("Giggle", false);
      });
    }

    //play blinking animation
    this.character.playTrack("Blink", true, 1);
  }

  enabled() {
    this.setInteractive();
  }

  disabled() {
    this.disableInteractive();
  }

  enterGame() {
    if (gameData.currentScene === "Intro") {
      let newX;
      if (this.ind === 1) newX = 300;
      else if (this.ind === 2) newX = this.scene.mid.x;
      else if (this.ind === 3) newX = 750;

      this.scene.addTween(this, 2500, { x: newX }, Phaser.Math.Easing.None,
        () => {
          if (this.ind === 3) {
            this.character.play("OutOfBreathLeft");
          } else {
            this.character.play("OutOfBreath");
          }

          // let rand = Phaser.Math.Between(1, 7);
          // if(rand === 1) this.character.play("Cheer", false);
          this.enabled();
          //this.character.play("Idle", false);
        });
    } else {
      this.shadow.setScale(0);
      this.character.play("Land", false);

      this.scene.playSound("custom_FB_enter");

      this.scene.addTween(this.shadow, 300, { scaleX: 1, scaleY: 1, delay: 800 }, Phaser.Math.Easing.Quadratic.In);
      this.scene.addTween(this, 1000, { y: 500 }, Phaser.Math.Easing.Quadratic.In);
    }
  }

  leaveGame() {
    if (gameData.currentScene === "Intro") {
      this.scene.killTween(this);
      this.disabled();
      this.character.play("RunningLeft", true);
      this.scene.addTween(this, 1500, { x: -200 }, Phaser.Math.Easing.Quadratic.In);
    } else {
      this.character.play("JumpOut", false);

      this.scene.playSound("custom_FB_leave");

      this.scene.addTween(this.shadow, 200, { scaleX: 0, scaleY: 0, delay: 700 }, Phaser.Math.Easing.Quadratic.In);
      this.scene.addTween(this, 500, { y: -50, delay: 800 }, Phaser.Math.Easing.Quadratic.In,
        () => { this.scene.cleanUp("Game"); });
    }
  }

  completeCheck(obj) {
    //console.log("checking anim", obj);
    if (this.isBlending === false) {
      if (obj.animation !== null) this.animComplete(obj);
    } else {
      return;
    }
  }

  animComplete(obj) {
    //console.log("complete", obj);
    if (obj.animation.name === "Blink") {
      this.character.clearTrack(1);
      let randDel = Phaser.Math.Between(0, 4000);
      this.scene.addDelay(randDel, () => { this.character.playTrack("Blink", true, 1); });
    }
    else if (obj.animation.name === "OutOfBreath" || obj.animation.name === "OutOfBreathLeft" || obj.animation.name === "Giggle") {
      this.enabled();

      this.character.play("Idle", true);
    }
    else if (obj.animation.name === "Land") {
      this.character.play("Idle", true);
    }
    else if (obj.animation.name === "Cheer") {
      this.character.spine.setScale(.65, .65);
      this.character.play("Idle", true);
    }

    if (obj.animation.name === "Idle" && gameData.currentScene === "Intro") {
      let rand = Phaser.Math.Between(1, 5);
      if (rand === 3) this.character.play("Cheer", false);
      else this.character.play("Idle", false);
    }
    else if (obj.animation.name === "Idle" && gameData.currentScene === "Customize") {
      return;
    }
  }

  ////// PAINT OPTIONS //////

  customizeUser() {
    this.stencil = gameData.fuzzStencil;
    this.color = gameData.fuzzColor;
    this.stencilColor = gameData.fuzzStencilColor;
    this.paintFuzzbug(gameData.fuzzStencilColor);
  }

  paintFuzzbug() {
    let colorCanvas = new ACanvas(this.scene, "cCanvas" + this.ind, 258, 259);
    if (this.stencil != "") {
      console.log(this.stencil);
      colorCanvas.addSquare(this.stencilColor);
      colorCanvas.setComposition(ACanvas.compositions.DESTINATION_OUT);
      colorCanvas.addImage(this.stencilData[this.stencil].x, this.stencilData[this.stencil].y, this.stencil);
      colorCanvas.setComposition(ACanvas.compositions.DESTINATION_OVER);
    }
    colorCanvas.addSquare(this.color);

    let spineCanvas = new ACanvas(this.scene, "sCanvas" + this.ind, this.atlasSize.width, this.atlasSize.height);
    spineCanvas.addImage(0, 0, this.textureKey);
    spineCanvas.setComposition(ACanvas.compositions.MULTIPLY);
    spineCanvas.context.drawImage(colorCanvas.context.canvas, this.bodyData.x, this.bodyData.y - 162);
    spineCanvas.setComposition(ACanvas.compositions.DESTINATION_IN);
    spineCanvas.addImage(0, 0, this.textureKey);

    // this.createCanvasDebug(spineCanvas);

    let gl = this.scene.game.context;
    let texture = gl.createTexture();

    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, spineCanvas.context.getImageData(0, 0, this.atlasSize.width, this.atlasSize.height));
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);

    this.character.spine.skeleton.slots[6].attachment.region.texture.texture = texture;
  }

  createCanvasDebug(canvas) {
    if (this._debug != null) this._debug.destroy();
    canvas.saveToTexture("spineCnv" + this.ind, () => {
      console.log("creating image");

      this._debug = this.scene.add.image(300, 300, "spineCnv" + this.ind).setDepth(9999);
    });
  }

  enabled() {
    this.setInteractive();
    this.scene.input.setDraggable(this);
  }

  disabled() {
    this.disableInteractive();
  }

  cleanUp() {
    if (this.character.spine.state) this.character.spine.state.clearListeners();
    if (this.scene != null) this.scene.textures.remove(this.textureKey);
    super.destroy();
  }
}